import { AdditionalInfoAccordion as BaseAdditionalInfoAccordion } from './AdditionalInfoAccordion';
import { BuyerInfoAccordion as BaseBuyerInfoAccordion } from './BuyerInfoAccordion';
import { CampaignDetails } from './CampaignDetails';
import { InformationAccordion as BaseInformationAccordion } from './InformationAccordion';
import { JobAccordion } from './JobAccordion';
import { JobHighlightsAccordion as BaseJobHighlightsAccordion } from './JobHighlightsAccordion';
import { JobInfoAccordion as BaseJobInfoAccordion } from './JobInfoAccordion';
import { JobLocationAccordion as BaseJobLocationAccordion } from './JobLocationAccordion';
import { QuestionsQualificationsAccordion as BaseQuestionsQualificationsAccordion } from './QuestionsQualificationsAccordion';
import { RatesAccordion as BaseRatesAccordion } from './RatesAccordion';
import { RequisitionInfoAccordion as BaseRequisitionInfoAccordion } from './RequisitionInfoAccordion';
import { ShiftInfoAccordion as BaseShiftInfoAccordion } from './ShiftInfoAccordion';
import { SystemInfoAccordion as BaseSystemInfoAccordion } from './SystemInfoAccordion';
import { VmsAccordion as BaseVmsAccordion } from './VmsAccordion';
import { withAccordionControl } from './withAccordionControl';

// Apply HOC to all accordion components
export const JobHighlightsAccordion = withAccordionControl(
  BaseJobHighlightsAccordion,
);
export const JobLocationAccordion = withAccordionControl(
  BaseJobLocationAccordion,
);
export const RatesAccordion = withAccordionControl(BaseRatesAccordion);
export const JobInfoAccordion = withAccordionControl(BaseJobInfoAccordion);
export const ShiftInfoAccordion = withAccordionControl(BaseShiftInfoAccordion);
export const VmsAccordion = withAccordionControl(BaseVmsAccordion);
export const InformationAccordion = withAccordionControl(
  BaseInformationAccordion,
);
export const SystemInfoAccordion = withAccordionControl(
  BaseSystemInfoAccordion,
);
export const BuyerInfoAccordion = withAccordionControl(BaseBuyerInfoAccordion);
export const RequisitionInfoAccordion = withAccordionControl(
  BaseRequisitionInfoAccordion,
);
export const AdditionalInfoAccordion = withAccordionControl(
  BaseAdditionalInfoAccordion,
);
export const QuestionsQualificationsAccordion = withAccordionControl(
  BaseQuestionsQualificationsAccordion,
);

// Re-export other components directly
export { CampaignDetails, JobAccordion };
